module.exports = __webpack_public_path__ + "img/aad.7c8a8578.svg";